import { defineStore } from "pinia"

export const useStudentWheelStore = defineStore("studentWheelStore", {
  state: () => ({
    modalOpen: false,
  }),

  actions: {
    setModalOpen(isOpen: boolean) {
      this.modalOpen = isOpen
      if (isOpen) {
        useGAEvent("teacher_tool_used", { tool: "student_wheel" })
      }
    },
  },
})
